module.exports = __webpack_public_path__ + "media/images/icons/telegram_logo-1d1787d0fb685b92a568aec7d606e1fe.svg";